import {
  Circle,
  Send,
  CheckCircle2,
  XCircle,
  AlertTriangle,
  Ban,
} from "lucide-react";

const STATUS_CONFIG: Record<
  string,
  {
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    color: string;
    bg: string;
  }
> = {
  draft: { label: "Draft", icon: Circle, color: "#6b7280", bg: "#f3f4f6" },
  sent: { label: "Sent", icon: Send, color: "#2563eb", bg: "#dbeafe" },
  paid: { label: "Paid", icon: CheckCircle2, color: "#16a34a", bg: "#dcfce7" },
  failed: { label: "Failed", icon: AlertTriangle, color: "#dc2626", bg: "#fee2e2" },
  void: { label: "Void", icon: Ban, color: "#6b7280", bg: "#e5e7eb" },
  refunded: { label: "Refunded", icon: XCircle, color: "#d97706", bg: "#fef3c7" },
};

export function InvoiceStatusBadge({ status }: { status: string }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;
  const Icon = config.icon;

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
      style={{ color: config.color, backgroundColor: config.bg }}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
}
